import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// intervals check
// window.activeIntervals = new Set();

// const originalSetInterval = window.setInterval;
// const originalClearInterval = window.clearInterval;

// window.setInterval = (callback, delay) => {
//   console.log(callback, delay);
//   const id = originalSetInterval(callback, delay);
//   window.activeIntervals.add(id);
//   return id;
// };
//
// window.clearInterval = (id) => {
//   originalClearInterval(id);
//   window.activeIntervals.delete(id);
// };
//
// const clearAllIntervals = () => {
//   window.activeIntervals.forEach(originalClearInterval);
//   window.activeIntervals.clear();
// };

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
);
window.addEventListener('error', (evt) => {
  window.console.error(evt, '__ERROR__');
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
